/* Common place for dealing with environment variables. */

import { getRegionKey } from "@certn/utils";

declare global {
  interface Window {
    env: Record<string, string | undefined>;
  }
}

function getEnvironmentVar(key: string, windowKey?: string) {
  if (window?.env && windowKey && window.env[windowKey]) {
    return window.env[windowKey];
  }
  return import.meta.env?.[key];
}

/**
 * Builds an object containing environment variables enabling runtime env vars for preview environments.
 * @returns {object} an object containing domainUrl, auth0AudienceUrl, auth0CallbackUrl
 */
export function getServerEnvironment() {
  const domainUrl = getEnvironmentVar(
    `VITE_DOMAIN_${getRegionKey().toUpperCase()}`,
    "DOMAIN"
  );
  const auth0AudienceUrl = getEnvironmentVar(
    "VITE_AUTH0_AUDIENCE",
    "AUTH0_AUDIENCE"
  );
  const auth0CallbackUrl = getEnvironmentVar(
    "VITE_AUTH0_CALLBACK_URL",
    "AUTH0_CALLBACK_URL"
  );
  const useWatermarksOnReports = getEnvironmentVar(
    "VITE_USE_WATERMARKS_ON_REPORTS"
  );
  const stripeCertnCanadaPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_CANADA_PUBLISHABLE_KEY",
    "STRIPE_CERTN_CANADA_PUBLISHABLE_KEY"
  );
  const stripeCertnCanadaPrepayPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY",
    "STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY"
  );
  const stripeCertnUsaPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_USA_PUBLISHABLE_KEY",
    "STRIPE_CERTN_USA_PUBLISHABLE_KEY"
  );
  const stripeCertnUsaPrepayPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY",
    "STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY"
  );
  const stripeCertnUkPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_UK_PUBLISHABLE_KEY",
    "STRIPE_CERTN_UK_PUBLISHABLE_KEY"
  );
  const stripeCertnUkPrepayPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY",
    "STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY"
  );
  const stripeCertnIntercheckPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_INTERCHECK_PUBLISHABLE_KEY",
    "STRIPE_INTERCHECK_PUBLISHABLE_KEY"
  );
  const stripeIntercheckPrepayPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY",
    "STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY"
  );
  const stripeIntercheckConsumerPublishableKey = getEnvironmentVar(
    "VITE_STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY",
    "STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY"
  );

  return {
    domainUrl,
    auth0AudienceUrl,
    auth0CallbackUrl,
    useWatermarksOnReports,
    stripeCertnCanadaPublishableKey,
    stripeCertnCanadaPrepayPublishableKey,
    stripeCertnUsaPublishableKey,
    stripeCertnUsaPrepayPublishableKey,
    stripeCertnUkPublishableKey,
    stripeCertnUkPrepayPublishableKey,
    stripeCertnIntercheckPublishableKey,
    stripeIntercheckPrepayPublishableKey,
    stripeIntercheckConsumerPublishableKey,
  };
}

export default getServerEnvironment();
